import React, { createContext, useContext, useState } from "react";

const PerformanceCardContext = createContext();

export const PerformanceCardProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen((prev) => !prev);

  return (
    <PerformanceCardContext.Provider value={{ isOpen, toggle, setIsOpen }}>
      {children}
    </PerformanceCardContext.Provider>
  );
};

export const usePerformanceCard = () => {
  const context = useContext(PerformanceCardContext);
  if (!context) {
    throw new Error(
      "usePerformanceCard must be used within a PerformanceCardProvider"
    );
  }
  return context;
};
